<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="row">
      <div class="col-5">
        <user-list v-model="users"></user-list>
      </div>
      <div class="col-7">
        <h4>ข้อความที่ต้องการส่ง</h4>
        <hr />
        <el-input class="message" type="textarea" v-model="message"></el-input>
        <div class="text-right mt-4">
          <sc-button variant="primary" @click="handleSubmit">บันทึก</sc-button>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Input } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import UserList from "../components/UserList";

export default {
  components: {
    PageWrapper,
    ScButton,
    ElInput: Input,
    UserList
  },
  data() {
    const title = "ส่งข้อความ";
    const search = "";
    const users = [];
    const message = "";

    return {
      title,
      search,
      users,
      message
    };
  },
  computed: {},
  created() {
    this.setup();
  },
  methods: {
    setup() {},
    async handleSubmit() {
      const to = this.users.map(user => {
        const userId = user.id;
        const homeId = user.homeId;
        const projectId = user.projectId;

        return {
          userId,
          homeId,
          projectId
        };
      });

      const detail = this.message;
      const params = {
        to,
        detail
      };

      try {
        await baanRueJaiClient.admin.greeting.postSend(params);

        alert("ส่งข้อความเรียบร้อย");
        this.message = "";
        this.users = [];
      } catch (error) {
        alert("ไม่สามารถส่งข้อความได้");
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/messaging/pages/MessagePage.vue